import { SVGProps } from "react";

const VirtualAccountIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={26}
    height={26}
    fill="none"
    viewBox="-1 -1 24 24"
    {...props}
  >
    <path
      d="M12.75 0.75H8.75C5.47077 0.75 3.83116 0.75 2.66891 1.56382C2.23891 1.8649 1.8649 2.23891 1.56382 2.66891C0.75 3.83116 0.75 5.47077 0.75 8.75C0.75 12.0292 0.75 13.6688 1.56382 14.8311C1.8649 15.2611 2.23891 15.6351 2.66891 15.9362C3.83116 16.75 5.47077 16.75 8.75 16.75H12.75C16.0292 16.75 17.6688 16.75 18.8311 15.9362C19.2611 15.6351 19.6351 15.2611 19.9362 14.8311C20.75 13.6688 20.75 12.0292 20.75 8.75C20.75 5.47077 20.75 3.83116 19.9362 2.66891C19.6351 2.23891 19.2611 1.8649 18.8311 1.56382C17.6688 0.75 16.0292 0.75 12.75 0.75Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M13.25 20.75L12.9345 20.3311C12.2233 19.3869 12.0469 17.9444 12.4968 16.75M8.25 20.75L8.5655 20.3311C9.27673 19.3869 9.45305 17.9444 9.00323 16.75"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path d="M5.75 20.75H15.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <path
      d="M12.75 6.75C12.75 7.85457 11.8546 8.75 10.75 8.75C9.64543 8.75 8.75 7.85457 8.75 6.75C8.75 5.64543 9.64543 4.75 10.75 4.75C11.8546 4.75 12.75 5.64543 12.75 6.75Z"
      fill="currentColor"
    />
    <path
      d="M6.75 12.75C8.58846 10.1546 12.8688 10.013 14.75 12.75M12.75 6.75C12.75 7.85457 11.8546 8.75 10.75 8.75C9.64543 8.75 8.75 7.85457 8.75 6.75C8.75 5.64543 9.64543 4.75 10.75 4.75C11.8546 4.75 12.75 5.64543 12.75 6.75Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export default VirtualAccountIcon;
